class NSSCartTemplate extends HTMLElement {
  
  constructor() {
    super();

    this.debug = false;
    this.frequencyChangeInProgress = false;
    this.previousSelectValues = new Map();

    this.els = {
      buyboxSummaries: document.querySelectorAll(`nss-buybox-summary-variant`),
      buyboxStickyATCs: document.querySelectorAll(`nss-buybox-sticky-atc-variant`),
    }
  }

  connectedCallback() {
    if (this.debug) console.log(`[NSS][Cart Template] Connected.`);

    this.initCartTemplate();
  }

  async apiGetCart() {
    return fetch(window.Shopify.routes.root + "cart.js", {
      method: "GET",
    })
      .then((response) => {
        return response.json();
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }

  async apiAddToCart(formData) {
    return fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      body: formData,
    })
      .then((response) => {
        return response.json();
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }

  async apiUpdate(updates) {
    return fetch(window.Shopify.routes.root + "cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ updates }),
    })
      .then((response) => {
        return response.json();
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }

  async apiChange(changes) {
    return fetch(window.Shopify.routes.root + "cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(changes),
    })
      .then((response) => {
        return response.json();
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }

  async fetchCartSection() {
    const parser = new DOMParser(),
          sectionID = this.getAttribute(`nss-parent-section-id`);

    let markup = await (await fetch(`?section_id=${sectionID}`)).text();

    return parser.parseFromString(markup, "text/html");

    // (new DOMParser).parseFromString(await (await fetch(`?section_id=nss-cart-drawer`)).text(), "text/html")
  }

  updateItemCount(sectionEl) {
    const newProductListEl = sectionEl.querySelector(`.nss-cart__items`),
          itemCountEls = document.querySelectorAll(`[nss-cart-count]`);

    itemCountEls.forEach((itemCountEl) => {
      itemCountEl.innerHTML =
        newProductListEl.getAttribute(`nss-cart-item-count`);
    });

    this.updateCountBadges(newProductListEl.getAttribute(`nss-cart-item-count`));
  }

  updateCountBadges(result) {
    const count = parseInt(result);
    if (this.debug) console.log(`[NSS][Cart Template] Updating badges, count:`, count);
    if (count < 100) {
      const countEls = document.querySelectorAll(`[nss-cart-badge-count]`);
      countEls.forEach((countEl) => {
        countEl.innerHTML = count;
      });
    }
  }

  reloadElements(sectionEl) {
    const reloadEls = this.querySelectorAll(`[nss-cart-reload]`);

    reloadEls.forEach((reloadEl) => {
      const reloadID = reloadEl.getAttribute(`nss-cart-reload`),
            updatedEl = sectionEl.querySelector(`[nss-cart-reload="${reloadID}"]`);

      if (updatedEl) {
        reloadEl.replaceWith(updatedEl);
      } else {
        reloadEl.remove();
      }
    });
  }

  reloadItemList(sectionEl) {
    const productListEl = this.querySelector(`.nss-cart__items`),
          newProductListEl = sectionEl.querySelector(`.nss-cart__items`);

    productListEl.replaceWith(newProductListEl);
  }

  async handleATC(e) {
    const formData = new FormData(e.target);
    const variantId = formData.get('id');
    const quantity = parseInt(formData.get('quantity')) || 1;
    const maxQty = 15;

    // Get the button that was clicked
    const clickedButton = e.target.closest('form')?.querySelector('[nss-btn-atc] button') || 
                          e.target.closest('[nss-btn-atc]')?.querySelector('button');
    
    // Set loading state on all Add to Cart buttons
    this.setATCButtonLoading(true);

    // Fetch current cart to check if variant already exists
    const cart = await this.apiGetCart();
    
    if (cart && cart.items) {
      // Calculate total quantity of all items with the same variant ID
      const totalQty = cart.items
        .filter(item => item.variant_id == variantId)
        .reduce((sum, item) => sum + item.quantity, 0);
      
      // Check if adding this quantity would exceed the max
      if (totalQty + quantity > maxQty) {
        // Calculate how many can still be added
        const remainingQty = Math.max(0, maxQty - totalQty);
        
        if (remainingQty === 0) {
          // Already at max, prevent adding and trigger message display
          if (this.debug) console.log(`[NSS][Cart Template] Cannot add more - already at max quantity of ${maxQty} for this variant`);
          
          // Remove loading state
          this.setATCButtonLoading(false);
          
          // Dispatch cart update event to ensure buybox message is visible
          document.dispatchEvent(new CustomEvent('cart:updated'));
          
          return;
        } else {
          // Limit the quantity to what can still be added
          formData.set('quantity', remainingQty);
          if (this.debug) console.log(`[NSS][Cart Template] Limiting quantity to ${remainingQty} (${totalQty} already in cart)`);
        }
      }
    }
    
    const result = await this.apiAddToCart(formData);
    if (this.debug) console.log(`[NSS][Cart Template] handleATC result:`, result);
    
    if (typeof result.status !== 'undefined') {
      // Handle error case
      if (this.debug) console.log(`[NSS][Cart Template] Add to cart failed!`, result);
      // Remove loading state on error
      this.setATCButtonLoading(false);
      // You might want to show an error message to the user here
    } else {
      // Update cart section FIRST, then open drawer
      try {
        const sectionEl = await this.fetchCartSection();
        this.updateItemCount(sectionEl);
        this.reloadItemList(sectionEl);
        this.reloadElements(sectionEl);
        this.refreshRecommendations();
        
        // Open cart drawer AFTER cart is updated
        if (typeof window.NSS_OPEN_CART_DRAWER === `function`) window.NSS_OPEN_CART_DRAWER();
        
        // Remove loading state after cart updates
        this.setATCButtonLoading(false);
        
        // Dispatch cart update event to update buybox messages
        document.dispatchEvent(new CustomEvent('cart:updated'));
      } catch (error) {
        if (this.debug) console.error(`[NSS][Cart Template] Error updating cart section:`, error);
        // Remove loading state on error
        this.setATCButtonLoading(false);
        // Still open cart drawer even if update failed
        if (typeof window.NSS_OPEN_CART_DRAWER === `function`) window.NSS_OPEN_CART_DRAWER();
      }
    }
  }

  setATCButtonLoading(isLoading) {
    const atcButtons = document.querySelectorAll(`[nss-btn-atc] button`);
    
    atcButtons.forEach((button) => {
      if (isLoading) {
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        button.classList.add('nss-button--loading');
        
        // Check if spinner already exists
        if (!button.querySelector('.nss-button__spinner')) {
          // Add spinner after the arrow icon (keep everything visible)
          const spinner = document.createElement('span');
          spinner.className = 'nss-button__spinner';
          spinner.innerHTML = '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="8" cy="8" r="6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-dasharray="9.42" stroke-dashoffset="9.42" opacity="0.3"/><circle cx="8" cy="8" r="6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-dasharray="9.42" stroke-dashoffset="4.71"><animate attributeName="stroke-dashoffset" dur="0.8s" values="9.42;0;9.42" repeatCount="indefinite"/><animateTransform attributeName="transform" type="rotate" dur="0.8s" values="0 8 8;360 8 8" repeatCount="indefinite"/></circle></svg>';
          
          // Find the arrow icon (last SVG element) and add spinner after it
          const arrowIcon = button.querySelector('svg:last-child');
          if (arrowIcon) {
            arrowIcon.insertAdjacentElement('afterend', spinner);
          } else {
            // If no arrow icon found, add spinner at the end
            button.appendChild(spinner);
          }
        }
      } else {
        button.disabled = false;
        button.removeAttribute('aria-busy');
        button.classList.remove('nss-button--loading');
        
        // Remove spinner only (keep text and arrow visible)
        const spinner = button.querySelector('.nss-button__spinner');
        if (spinner) {
          spinner.remove();
        }
      }
    });
  }

  async handleRemove(e) {
    const cartItemEl = e.target.closest(`.nss-cart__item`),
          itemKey = cartItemEl.getAttribute(`nss-cart-item-key`),
          bundleKeys = cartItemEl.getAttribute(`nss-cart-item-bundle-keys`)?.split(',') || [];

    let updates = {};

    if (bundleKeys.length > 0) {
      bundleKeys.map(key => {
        updates[key] = 0;
      });
    } else {
      updates[itemKey] = 0;
    }

    const result = await this.apiUpdate(updates);
    if (this.debug) console.log(`[NSS][Cart Template] handleRemove result:`, result);

    if (typeof result.status !== 'undefined') {
      const cartItemParentEl = cartItemEl.parentElement,
            cartErrorEl = cartItemParentEl.querySelector(`.nss-cart__item-error`);

      cartErrorEl.textContent = `${result.message}: ${result.description}`;
      cartItemEl.setAttribute(`nss-cart-item-loading`, false);

      if (this.debug) console.log(`[NSS][Cart Template] Remove failed!`);
    } else {
      const sectionEl = await this.fetchCartSection();
      this.updateItemCount(sectionEl);
      this.reloadItemList(sectionEl);
      this.reloadElements(sectionEl);
  
      // Dispatch cart update event to update buybox messages
      document.dispatchEvent(new CustomEvent('cart:updated'));
  
      if (this.debug) console.log(`[NSS][Cart Template] Remove completed!`);
    }
  }

  async handleQtyIncrement(e) {
    const cartItemEl = e.target.closest(`.nss-cart__item`),
          itemKey = cartItemEl.getAttribute(`nss-cart-item-key`),
          qtyInputEl = cartItemEl.querySelector(`[name="updates[]"]`);

    let qtyMax = parseInt(qtyInputEl.getAttribute(`max`)),
        qtyCurrent = parseInt(qtyInputEl.value),
        qtyFinal = Math.min(qtyCurrent + 1, qtyMax),
        updates = {};

    // Check total quantity across all items with same variant
    const cart = await this.apiGetCart();
    if (cart && cart.items) {
      const currentItem = cart.items.find(item => item.key === itemKey);
      if (currentItem) {
        const variantId = currentItem.variant_id;
        const maxQty = 15;
        
        // Calculate total quantity of all items with the same variant ID
        const totalQty = cart.items
          .filter(item => item.variant_id == variantId)
          .reduce((sum, item) => {
            // If this is the current item, use the new quantity, otherwise use existing
            if (item.key === itemKey) {
              return sum + qtyFinal;
            }
            return sum + item.quantity;
          }, 0);
        
        // If total would exceed max, prevent increment
        if (totalQty > maxQty) {
          // Calculate max allowed for this item
          const otherItemsQty = cart.items
            .filter(item => item.variant_id == variantId && item.key !== itemKey)
            .reduce((sum, item) => sum + item.quantity, 0);
          
          qtyFinal = Math.max(qtyCurrent, Math.min(qtyCurrent + 1, maxQty - otherItemsQty));
          
          if (qtyFinal === qtyCurrent) {
            // Can't increment, show message
            const cartItemParentEl = cartItemEl.parentElement,
                  cartErrorEl = cartItemParentEl.querySelector(`.nss-cart__item-error`);
            
            if (cartErrorEl) {
              cartErrorEl.textContent = `Maximum quantity of ${maxQty} reached for this variant`;
              setTimeout(() => {
                cartErrorEl.textContent = '';
              }, 3000);
            }
            cartItemEl.setAttribute(`nss-cart-item-loading`, false);
            return;
          }
        }
      }
    }

    updates[itemKey] = qtyFinal;

    const result = await this.apiUpdate(updates);
    if (this.debug) console.log(`[NSS][Cart Template] handleQtyIncrement result:`, result);

    if (typeof result.status !== 'undefined') {
      const cartItemParentEl = cartItemEl.parentElement,
            cartErrorEl = cartItemParentEl.querySelector(`.nss-cart__item-error`);

      cartErrorEl.textContent = `${result.message}: ${result.description}`;
      cartItemEl.setAttribute(`nss-cart-item-loading`, false);

      if (this.debug) console.log(`[NSS][Cart Template] Quantity increment failed!`);
    } else {
      const sectionEl = await this.fetchCartSection();
      this.updateItemCount(sectionEl);
      this.reloadItemList(sectionEl);
      this.reloadElements(sectionEl);
  
      // Dispatch cart update event to update buybox messages
      document.dispatchEvent(new CustomEvent('cart:updated'));
  
      if (this.debug) console.log(`[NSS][Cart Template] Quantity increment completed!`);
    }
  }

  async handleQtyDecrement(e) {
    const cartItemEl = e.target.closest(`.nss-cart__item`),
          itemKey = cartItemEl.getAttribute(`nss-cart-item-key`),
          qtyInputEl = cartItemEl.querySelector(`[name="updates[]"]`);

    let qtyMin = parseInt(qtyInputEl.getAttribute(`min`)),
        qtyCurrent = parseInt(qtyInputEl.value),
        qtyFinal = Math.max(qtyCurrent - 1, qtyMin),
        updates = {};
    
    if (qtyFinal <= 0) {
      this.handleRemove(e);
      return;
    }

    updates[itemKey] = qtyFinal;

    const result = await this.apiUpdate(updates);
    if (this.debug) console.log(`[NSS][Cart Template] handleQtyDecrement result:`, result);

    if (typeof result.status !== 'undefined') {
      const cartItemParentEl = cartItemEl.parentElement,
            cartErrorEl = cartItemParentEl.querySelector(`.nss-cart__item-error`);

      cartErrorEl.textContent = `${result.message}: ${result.description}`;
      cartItemEl.setAttribute(`nss-cart-item-loading`, false);

      if (this.debug) console.log(`[NSS][Cart Template] Quantity decrement failed!`);
    } else {
      const sectionEl = await this.fetchCartSection();
      this.updateItemCount(sectionEl);
      this.reloadItemList(sectionEl);
      this.reloadElements(sectionEl);
  
      // Dispatch cart update event to update buybox messages
      document.dispatchEvent(new CustomEvent('cart:updated'));
  
      if (this.debug) console.log(`[NSS][Cart Template] Quantity decrement completed!`);
    }
  }

  async handleFrequencyUpgrade(e) {
    const cartItemEl = e.target.closest(`.nss-cart__item`),
          itemKey = cartItemEl.getAttribute(`nss-cart-item-key`),
          qtyInputEl = cartItemEl.querySelector(`[name="updates[]"]`),
          sellingPlanId = e.target.getAttribute(`nss-selling-plan-id`);
    
    let qtyCurrent = parseInt(qtyInputEl.value),
        changes = {};

    changes["id"] = itemKey;
    changes["quantity"] = qtyCurrent;
    changes["selling_plan"] = sellingPlanId;

    const result = await this.apiChange(changes);
    if (this.debug) console.log(`[NSS][Cart Template] handleFrequencyUpgrade result:`, result);

    if (typeof result.status !== 'undefined') {
      const cartItemParentEl = cartItemEl.parentElement,
            cartErrorEl = cartItemParentEl.querySelector(`.nss-cart__item-error`);

      cartErrorEl.textContent = `${result.message}: ${result.description}`;
      cartItemEl.setAttribute(`nss-cart-item-loading`, false);

      if (this.debug) console.log(`[NSS][Cart Template] Upgrade frequency failed!`);
    } else {
      const sectionEl = await this.fetchCartSection();
      this.reloadItemList(sectionEl);
      this.reloadElements(sectionEl);
  
      if (this.debug) console.log(`[NSS][Cart Template] Upgrade frequency completed!`);
    }
  }

  async handleFrequencyChange(e) {
    const cartItemEl = e.target.closest(`.nss-cart__item`),
          itemKey = cartItemEl.getAttribute(`nss-cart-item-key`),
          qtyInputEl = cartItemEl.querySelector(`[name="updates[]"]`),
          sellingPlanId = e.target.value;

    if (cartItemEl) {
      cartItemEl.setAttribute(`nss-cart-item-loading`, true);
    }
    
    let qtyCurrent = parseInt(qtyInputEl.value),
        changes = {};
  
    changes["id"] = itemKey;
    changes["quantity"] = qtyCurrent;
    
    // Explicitly set selling_plan to null for one-time purchase (empty value)
    // Otherwise set the selling plan ID
    if (sellingPlanId === "" || sellingPlanId === null || sellingPlanId === undefined) {
      changes["selling_plan"] = null;
    } else {
      changes["selling_plan"] = sellingPlanId;
    }
  
    const result = await this.apiChange(changes);
    if (this.debug) console.log(`[NSS][Cart Template] handleFrequencyChange result:`, result);
  
    // Reset the in-progress flag
    this.frequencyChangeInProgress = false;
  
    if (typeof result.status !== 'undefined') {
      const cartItemParentEl = cartItemEl.parentElement,
            cartErrorEl = cartItemParentEl.querySelector(`.nss-cart__item-error`);
  
      cartErrorEl.textContent = `Error: ${result.message}`;
      if (cartItemEl) {
        cartItemEl.setAttribute(`nss-cart-item-loading`, false);
      }
  
      if (this.debug) console.log(`[NSS][Cart Template] Change frequency failed!`);
    } else {
      const sectionEl = await this.fetchCartSection();
      this.reloadItemList(sectionEl);
      this.reloadElements(sectionEl);
  
      if (this.debug) console.log(`[NSS][Cart Template] Change frequency completed!`);
    }
  }

  startItemLoading(e) {
    const cartItemEl = e.target.closest(`.nss-cart__item`);
    cartItemEl.setAttribute(`nss-cart-item-loading`, true);
  }

  async refreshCart() {
    const sectionEl = await this.fetchCartSection();
    this.updateItemCount(sectionEl);
    this.reloadItemList(sectionEl);
    this.reloadElements(sectionEl);
    this.refreshRecommendations();
    if (typeof window.NSS_OPEN_CART_DRAWER === `function`) window.NSS_OPEN_CART_DRAWER();
  }

  initCartTemplate() {
    // Attach 'submit' events to nss-main as delegator
    const mainEl = document.querySelector(`[nss-main]`);
  
    window.NSS_REFRESH_AND_OPEN_CART = () => {
      this.refreshCart();
    };
  
    // Document-level listening for ATC events
    document.addEventListener(`submit`, (e) => {
      if (e.target.classList.contains(`shopify-product-form`) || e.target.getAttribute(`action`) === `/cart/add`) {
        e.preventDefault();
        if (this.debug) console.log(`[NSS][Cart Template] ATC form intercepted!`)
        this.handleATC(e);
      }
    });
  
    document.addEventListener(`click`, (e) => {
      let clickedName = e.target.getAttribute(`name`);
  
      if (this.debug) console.log(`[NSS][Cart Template] clickedName:`, clickedName);
  
      if (clickedName === "add") {
        e.preventDefault();
        if (this.debug) console.log(`[NSS][Cart Template] ATC button click intercepted!`);
        const fakeEvent = {
          target: e.target.closest(`form`),
        }
        this.handleATC(fakeEvent);
      }
    });
  
    // Attach other events to nss-cart-drawer as delegator
    this.addEventListener(`click`, (e) => {
      // Only ignore actual select elements - not buttons or other elements in the frequency container
      const isSelectElement = e.target.tagName === 'SELECT' || e.target.closest('select');
      
      if (isSelectElement) {
        // Stop propagation to ensure nothing interferes with select
        e.stopPropagation();
        return;
      }
      
      let eventType = e.target.getAttribute(`nss-cart-event`);
    
      switch (eventType) {
        case "remove":
          e.preventDefault();
          if (this.debug) console.log(`[NSS][Cart Template] Remove event!`);
          this.startItemLoading(e);
          this.handleRemove(e);
          break;
    
        case "qty-increment":
          e.preventDefault();
          if (this.debug) console.log(`[NSS][Cart Template] Quantity increment event!`);
          this.startItemLoading(e);
          this.handleQtyIncrement(e);
          break;
    
        case "qty-decrement":
          e.preventDefault();
          if (this.debug) console.log(`[NSS][Cart Template] Quantity decrement event!`);
          this.startItemLoading(e);
          this.handleQtyDecrement(e);
          break;
    
        case "frequency-upgrade":
          e.preventDefault();
          if (this.debug) console.log(`[NSS][Cart Template] Frequency upgrade event!`);
          this.startItemLoading(e);
          this.handleFrequencyUpgrade(e);
          break;
      }
    });
  
    // Initialize select values when cart loads
    const initializeSelectValues = () => {
      const selects = this.querySelectorAll('select[nss-cart-event="frequency-change"]');
      selects.forEach(select => {
        if (!this.previousSelectValues.has(select)) {
          this.previousSelectValues.set(select, select.value);
          select.setAttribute('data-previous-value', select.value);
        }
      });
    };
    
    // Initialize on load
    initializeSelectValues();
    
    // Re-initialize after cart updates
    const observer = new MutationObserver(() => {
      initializeSelectValues();
    });
    
    observer.observe(this, { childList: true, subtree: true });
  
    // Only listen to change events - DO NOT preventDefault!
    this.addEventListener(`change`, (e) => {
      let eventType = e.target.getAttribute(`nss-cart-event`);
    
      switch (eventType) {
        case "frequency-change":
          // Prevent multiple rapid changes
          if (this.frequencyChangeInProgress) {
            if (this.debug) console.log(`[NSS][Cart Template] Frequency change already in progress, ignoring.`);
            return;
          }
  
          // Get previous value with fallback
          const previousValue = this.previousSelectValues.get(e.target) || e.target.getAttribute('data-previous-value') || '';
          const currentValue = e.target.value;
  
          // Only process if value actually changed
          if (previousValue === currentValue) {
            if (this.debug) console.log(`[NSS][Cart Template] Value didn't change (${previousValue} === ${currentValue}), ignoring.`);
            return;
          }
  
          if (this.debug) console.log(`[NSS][Cart Template] Frequency change event! Previous: ${previousValue}, New: ${currentValue}`);
  
          // Update stored value
          this.previousSelectValues.set(e.target, currentValue);
          e.target.setAttribute('data-previous-value', currentValue);
          
          this.frequencyChangeInProgress = true;
          const selectElement = e.target;
          const newValue = selectElement.value;
          
          // Wait to ensure dropdown has closed naturally
          setTimeout(() => {
            // Only proceed if element still exists and value is still the new value
            if (document.contains(selectElement) && selectElement.value === newValue) {
              this.handleFrequencyChange(e);
            } else {
              this.frequencyChangeInProgress = false;
              if (this.debug) console.log(`[NSS][Cart Template] Frequency change cancelled - element changed`);
            }
          }, 500);
          break;
      }
    }); // NO preventDefault here!
  
    // prepareRecommendations
    this.prepareRecommendations();
  }

  refreshRecommendations() {
    const productRecommendationsEls = document.querySelectorAll(`[nss-recommendations-id]`);
    productRecommendationsEls.forEach((productRecommendationsEl) => {
      const url = productRecommendationsEl.dataset.url;
      const id = productRecommendationsEl.getAttribute(`nss-recommendations-id`);

      productRecommendationsEl.setAttribute(`nss-recommendations-loading`, true);
    
      fetch(url)
        .then(response => {
          productRecommendationsEl.setAttribute(`nss-recommendations-loading`, false);
          return response.text();
        })
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector(`[nss-recommendations-id="${id}"]`);
  
          if (recommendations && recommendations.innerHTML.trim().length) {
            productRecommendationsEl.innerHTML = recommendations.innerHTML;
            productRecommendationsEl.style.display = `flex`;
          }
        })
        .catch(e => {
          productRecommendationsEl.style.display = `none`;
          console.error(e);
        });
    });
  }

  prepareRecommendations() {
    const productRecommendationsEls = document.querySelectorAll(`[nss-recommendations-id]`);
    productRecommendationsEls.forEach((productRecommendationsEl) => {
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
    
        observer.unobserve(productRecommendationsEl);
    
        const url = productRecommendationsEl.dataset.url;
        const id = productRecommendationsEl.getAttribute(`nss-recommendations-id`);
        productRecommendationsEl.setAttribute(`nss-recommendations-loading`, true);

        if (this.debug) console.log(`[NSS][Cart Template] Recommendations url:`, url);
        if (this.debug) console.log(`[NSS][Cart Template] Recommendations id:`, id);
    
        fetch(url)
          .then(response => {
            productRecommendationsEl.setAttribute(`nss-recommendations-loading`, false);
            return response.text();
          })
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector(`[nss-recommendations-id="${id}"]`);
    
            if (recommendations && recommendations.innerHTML.trim().length) {
              productRecommendationsEl.innerHTML = recommendations.innerHTML;
              productRecommendationsEl.style.display = `flex`;
            } else {
              productRecommendationsEl.style.display = `none`;
            }
          })
          .catch(e => {
            productRecommendationsEl.style.display = `none`;
            console.error(e);
          });
      };
      const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});
      observer.observe(productRecommendationsEl);
    });
  }
}

let elementName = `nss-cart-template`;
if (typeof customElements.get(elementName) === `undefined`) {
  customElements.define(elementName, NSSCartTemplate);
} else {
  console.warn(`[NSS] Element '${elementName}' already defined.`)
}
